import React from "react";
import { Grid, Box } from "@mui/material";

const PageTop = ({ img, title, smallTitle, bottom = 55 }) => {
  return (
    <Grid container>
      <Grid
        md={8}
        sm={12}
        xs={12}
        item
        sx={{
          backgroundImage: `url("${img}")`,
          backgroundPosition: `right 35% bottom ${bottom}%`,
          backgroundSize: "cover",
        }}
      ></Grid>
      <Grid
        md={4}
        sm={12}
        xs={12}
        item
        sx={{
          backgroundColor: "#212a2f",
          color: "white",
          height: { md: 400, sm: 200 },
          px: 5,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          textAlign: "center",
          py: { xs: 5, md: 0 },
        }}
      >
        <Box sx={{ fontSize: "25px", fontWeight: 400, lineHeight: "1.4em" }}>
          {title}
        </Box>
        <Box sx={{ pt: 3, lineHeight: "200%" }}>{smallTitle}</Box>
      </Grid>
    </Grid>
  );
};

export default PageTop;
